var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newFolder(data) {
    var instance = {
        __type: "Folder:#DecisionsFramework.ServiceLayer.Services.Folder",
        FolderID: null,
        EntityName: null,
        FolderBehaviorType: null,
        ShowInTree: true,
        ShowInUserPortal: null,
        SubMenuBehavior: 0 /* SubMenuBehavior.Default */,
        SubMenuGroupName: null,
        CanBeRoot: true,
        HasSpecifiedView: null,
        DefaultPageName: null,
        FolderOrder: 0,
        FullPath: null,
        NestingLevel: 0,
        IsSystemFolder: false,
        FolderTypeName: null,
        SecurityFolderId: null,
        IsSecurityFolder: false,
        HasSubFolders: false,
        CanBeExpanded: false,
        AdministratorViewOnly: false,
        HistoryFolderID: null,
        AllTagsData: null,
        EntityDescription: null,
        State: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        CreatedBy: null,
        ModifiedBy: null,
        Archived: false,
        ArchivedBy: null,
        ArchivedDate: new Date('0001-01-01T00:00:00Z'),
        Deleted: false,
        DeletedBy: null,
        DeletedOn: new Date('0001-01-01T00:00:00Z'),
        CustomLongDescription: null,
        CustomShortDescription: null
    };
    return __assign(__assign({}, instance), data);
}
export function isFolder(object) {
    return object.__type === "Folder:#DecisionsFramework.ServiceLayer.Services.Folder";
}
